import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["container", "trackableLink"]

    connect() {
        console.log("Recommendations controller connected")
    }

    trackClick(event) {
        const articleId = event.currentTarget.dataset.articleId
        const source = event.currentTarget.dataset.source || "unknown"

        // Track the click
        fetch(`/recommendations/track_click?article_id=${articleId}&source=${source}`, {
            method: 'GET',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
            }
        })

        // Continue with the navigation
    }

    refresh() {
        const url = this.element.dataset.refreshUrl
        const clientId = this.element.dataset.clientId
        const limit = this.element.dataset.limit || 5

        fetch(`${url}?client_id=${clientId}&limit=${limit}`, {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
                'Accept': 'text/javascript'
            }
        })
            .then(response => response.text())
            .then(html => {
                this.containerTarget.innerHTML = html
            })
    }
}